'use client';

import React from 'react';
import { CanLogoIcon } from '@/../public/assets/icons';
import { Box, Text } from '@chakra-ui/react';
import 'react-phone-input-2/lib/style.css';
import { PersonalDetailsProps } from './types/template.types';
import PersonalDetails from '../forms/personal-details/PersonalDetails';

const UserDetails = ({ next, details, previous }: PersonalDetailsProps) => {
   return (
      <>
         <Box minH="72px">
            <CanLogoIcon />
         </Box>
         <Text
            as="h2"
            color="white"
            fontSize={{ base: '4xl', sm: '5xl', md: '12xl' }}
            fontWeight="bold"
            textAlign="center"
         >
            PERSONAL DETAILS
         </Text>
         <Text color="white" textStyle="md" textAlign="center" mt="-10px" mb="2">
            Please enter your personal details.
            <br /> Your data is secure.
         </Text>
         <PersonalDetails next={next} details={details} previous={previous} />
      </>
   );
};

export default UserDetails;
